import React from 'react';
import { Box, Stack } from '@mui/material';
import BidHistoryPanel from './BidHistoryPanel';
import JobPaymentsTimeline from './JobPaymentsTimeline';
import JobEmailEventsPanel from './JobEmailEventsPanel';

const JobActivitySection = ({
	jobId,
	bids,
	paymentTimeline = [],
	emailEventsRefreshKey = 0,
}) => {
	const hasBidHistory = bids && bids.length > 1;
	const hasPayments = paymentTimeline.length > 0;

	return (
		<Stack spacing={{ xs: 2.5, md: 3 }}>
			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: {
						xs: '1fr',
						lg: hasPayments ? '1fr 1fr' : '1fr',
					},
					gap: { xs: 2.5, md: 3 },
					alignItems: 'start',
				}}
			>
				{hasPayments ? (
					<JobPaymentsTimeline paymentTimeline={paymentTimeline} />
				) : null}
				<JobEmailEventsPanel
					jobId={jobId}
					refreshKey={emailEventsRefreshKey}
				/>
			</Box>
			{hasBidHistory ? <BidHistoryPanel bids={bids} /> : null}
		</Stack>
	);
};

export default JobActivitySection;
